import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <h2 className="section-title">About Ruma Palace</h2>
        <p className="section-subtitle">Comfort and Convenience in Ujjain</p>
        
        <div className="about-content">
          <div className="about-text">
            <h3>Welcome to Ruma Palace</h3>
            <p>
              Ruma Palace Hotel is your perfect accommodation choice in Ujjain, offering 
              comfortable and well-maintained rooms with all modern amenities. Whether you're 
              visiting for pilgrimage, tourism, or business, we ensure a pleasant and memorable stay.
            </p>
            <p>
              Our hotel features 11 thoughtfully designed rooms - 9 comfortable double bed rooms 
              perfect for couples or solo travelers, and 2 spacious four-person rooms ideal for 
              families. We also offer a large group hall that can accommodate up to 12 people, 
              perfect for gatherings, meetings, or events. Every room is equipped with air conditioning, 
              clean modern bathrooms with hot and cold water, television, high-speed WiFi, power 
              inverter backup, and complimentary toiletries.
            </p>
            <div className="about-features">
              <div className="feature-item">
                <div className="feature-icon">🏨</div>
                <h4>11 Comfortable Rooms</h4>
                <p>Well-appointed rooms with modern amenities</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">📍</div>
                <h4>Prime Ujjain Location</h4>
                <p>Conveniently located in the heart of Ujjain</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">✨</div>
                <h4>Modern Facilities</h4>
                <p>AC, WiFi, TV, and all essential amenities</p>
              </div>
            </div>
          </div>
          <div className="about-image">
            <div className="map-container">
              <a 
                href="https://maps.app.goo.gl/igLrVJ1N6JRBnfmi9" 
                target="_blank" 
                rel="noopener noreferrer"
                className="map-clickable"
              >
                <div className="map-preview" style={{backgroundImage: 'url(/images/about/main.jpg)'}}>
                  <div className="map-preview-overlay"></div>
                  <div className="map-preview-content">
                    <div className="map-icon-large">📍</div>
                    <h4>Ruma Palace Hotel</h4>
                    <p>Ujjain, Madhya Pradesh</p>
                    <div className="map-button">
                      <span>View on Google Maps</span>
                      <span className="map-arrow">→</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

